module.exports = {"id":"dp2_2l1q4","text":"Sharing Through Digital Technologies","instructions":"Who can decide what information or content you share online?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.2","questionType":"PickOne","random":true,"options":[{"id":"dp2_2l1q4-a1","text":"The individual sharing the content","score":1.8},{"id":"dp2_2l1q4-a2","text":"The platform automatically","score":0},{"id":"dp2_2l1q4-a3","text":"Anyone who sees it","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.2/l1q4.json
// module id = 1013
// module chunks = 41